import React from 'react';
import { Redirect } from 'react-router';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import RoleService from '../../services/utility/role';
import Receipts from './receipts/receipts.component';
import ReceiptDetails from './receipts/receipts.details.component';
import ReverseReceipt from './receipts/reverse.receipt.component';
import RefundReceipt from './receipts/refund.receipt.component';

const roleService = new RoleService();

export default function ReceiptRoutersComponent(props) {
  const { path } = useRouteMatch();
  console.log(path);

  // const hasAccess = roleService.checkRouteAccess(props, 'RECEIPT');
  const hasAccess = true;
  if (hasAccess) {
    return (
      <React.Fragment>
        <Switch>
          <Route exact path="/receipts/refund-receipt" component={RefundReceipt} />
          <Route exact path="/receipts/reverse-receipt" component={ReverseReceipt} />
          <Route exact path={path}>
            <Receipts />
          </Route>
          <Route exact path="/receipts" component={Receipts} />
          <Route exact path="/receipts/:id" component={ReceiptDetails} />
        </Switch>
      </React.Fragment>
    );
  }

  return (
    <Redirect
      to={{
        pathname: '/unauthorized',
        state: {
          from: props.location,
        },
      }}
    />
  );
}
